import { useFetchGetByIdSolicitudCanje } from "@/shared/actions/erp/marketing";
import SaveSolicitudesEventoCanje from "../../shared/saveSolicitudesEventoCanje/SaveSolicitudesEventoCanje";
import { useParams } from "react-router-dom";
import { ISolicitudCanje } from "@/shared/interfaces";

const EditSolicitudesCanje = ()=>{

  const {idsolicitud} = useParams()
  const { data:dataSolicitudCanje, isLoading:isLoadingSolicitudCanje } = useFetchGetByIdSolicitudCanje(idsolicitud!)

  if (isLoadingSolicitudCanje) return null 

  return(
    <SaveSolicitudesEventoCanje title="Editar Solicitud de Canje" dataSolicitud={dataSolicitudCanje?.data as ISolicitudCanje}/>
  )
}
export default EditSolicitudesCanje;